export default __webpack_public_path__ + "static/media/watershed.5f1acb79.jpg";